<template>
  <vs-row>
    <vs-row class="my-5 mx-4">
      <vs-col vs-lg="5" vs-sm="12">
        <vs-row>
          <vs-button
            class="pr-15 mr-4"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addNewData"
            >Add New</vs-button
          >
          <vs-button
            :disabled="selected.length <= 0 || selected.length > 1"
            class="pl-8 ml-4 font-semibold center"
            type="filled"
            :color="actionBtnClr"
            @click="duplicate()"
            >Duplicate</vs-button
          >
          <vs-button
            :disabled="selected.length <= 0"
            class="pl-8 ml-4 font-semibold center"
            type="filled"
            :color="actionBtnClr"
            @click="confirmDelete = true"
            >Delete</vs-button
          >
        </vs-row>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="12">
        <vs-row class="mt-0">
          <vs-button
            disabled
            class="pl-0 ml-2 font-semibold center"
            type="filled"
            :color="actionBtnClr"
            @click="confirmDelete = true"
            style="background: tansparent"
            >Filter Expired Promos</vs-button
          >
          <vs-switch
            class="mt-2"
            style="background: rgb(29, 32, 36) none repeat scroll 0% 0%"
            v-model="filterExpired"
            @change="getPromoCards('search')"
          />
        </vs-row>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <input
            maxLength="30"
            type="text"
            name="search"
            class="search px-4 w-1/3 py-3 shadow-lg"
            placeholder="Search..."
            @input="getPromoCards('search')"
            v-on-clickaway="closeColorList"
            @click="handleFilter"
            v-model="search"
          />
        </vs-row>
        <vs-row>
          <div class="dropdown2 mt-1 w-full" id="maindropdown">
            <div class="dropdown2-content" v-show="toggleColorList">
              <div
                class=""
                @click="searchHashtags(hashtag)"
                :key="index"
                v-for="(hashtag, index) in hashtagList"
              >
                <h6 class="my-2">{{ "#" + hashtag }}</h6>
              </div>
            </div>
          </div>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row class="tblBgClrPending shadow-lg mx-4">
      <vs-table
        id="table1"
        multiple
        v-model="selected"
        :max-items="itemsPerPage"
        :data="promoCardsList"
        class="w-full"
        hoverFlat
      >
        <template slot="thead">
          <vs-th> LOGO</vs-th>

          <vs-th class="th-left-aligned" sort-key="order_status"
            >HEADLINE</vs-th
          >
          <vs-th class="th-left-aligned" sort-key="order_status"
            >SHORT DESCRIPTION</vs-th
          >

          <vs-th sort-key="order_status">END DATE</vs-th>
          <vs-th sort-key="order_status">HASHTAGS</vs-th>
          <vs-th sort-key="order_status">CREATED BY</vs-th>
          <vs-th sort-key="order_status">CREATED ON</vs-th>
          <vs-th sort-key="order_status">DISPLAY ON DASH</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr
              vs-align="center"
              style="word-wrap: anywhere"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td
                class="img-container center"
                @click.native.stop="reviewData(tr)"
              >
                <vue-load-image>
                  <img
                    slot="image"
                    :src="
                      tr.logo
                        ? $ApiKeys.IMAGE_BASE_URL + tr.logo
                        : require('@/assets/images/no_preview.jpg')
                    "
                    width="77"
                    height="49"
                  />
                  <img
                    slot="preloader"
                    src="@/assets/images/image-loader.gif"
                    width="77"
                    height="49"
                  />
                  <div slot="error">
                    <img
                      slot="image"
                      :src="require('@/assets/images/no_preview.jpg')"
                      width="77"
                      height="49"
                    />
                  </div>
                </vue-load-image>
              </vs-td>

              <vs-td @click.native.stop="reviewData(tr)">
                <p class="font-medium">
                  {{ tr.headline ? tr.headline : "Not Available" }}
                </p>
              </vs-td>
              <vs-td style="width: 250px" @click.native.stop="reviewData(tr)">
                <p class="font-medium">
                  {{
                    tr.short_description
                      ? tr.short_description.length > 90
                        ? tr.short_description.toString().substring(0, 90) +
                          "..."
                        : tr.short_description
                      : "Not Available"
                  }}
                </p>
              </vs-td>

              <vs-td class="center" @click.native.stop="reviewData(tr)">
                <p v-if="tr.end_date" class="font-medium">
                  {{ tr.end_date | formatDate }}
                </p>
                <p v-else class="font-medium">
                  {{ "N/A" }}
                </p>
              </vs-td>
              <vs-td class="centerdate" @click.native.stop="reviewData(tr)">
                <p v-if="tr.primary_hashtag_id" class="font-medium">
                  {{ tr.primary_hashtag_id.name | capitalize }}
                </p>
                <p v-else class="font-medium">
                  {{ "N/A" }}
                </p>
              </vs-td>
              <vs-td class="centerdate" @click.native.stop="reviewData(tr)">
                <div v-if="tr.is_created_by">
                  <div v-if="tr.is_created_by == 'admin'">
                    <div
                      v-if="
                        tr.adminId &&
                        (tr.adminId.firstname || tr.adminId.lastname)
                      "
                    >
                      <p class="font-medium">
                        {{
                          tr.adminId && tr.adminId.firstname
                            ? tr.adminId.firstname +
                              " " +
                              (tr.adminId.lastname ? tr.adminId.lastname : "")
                            : "" | capitalize
                        }}
                      </p>
                      <p class="small-font">
                        {{ "ADMIN" }}
                      </p>
                    </div>
                    <div v-else>
                      <p>
                        {{ "ADMIN" }}
                      </p>
                    </div>
                  </div>
                  <div v-if="tr.is_created_by == 'user'">
                    <p v-if="tr.profile != undefined" class="font-medium">
                      {{
                        tr.profile && tr.profile.firstname
                          ? tr.profile.firstname +
                            " " +
                            (tr.profile.lastname ? tr.profile.lastname : "")
                          : "" | capitalize
                      }}
                    </p>
                    <p class="small-font">
                      {{ "USER" }}
                    </p>
                  </div>
                </div>
                <div v-else>
                  <p class="font-medium">
                    {{ "ADMIN" }}
                  </p>
                </div>
              </vs-td>
              <vs-td class="centerdate" @click.native.stop="reviewData(tr)">
                <p v-if="tr.creation_date" class="font-medium">
                  {{ tr.creation_date | formatDate }}
                </p>
                <p v-else class="font-medium">
                  {{ "N/A" }}
                </p>
              </vs-td>
              <vs-td
                class="img-container center"
                @click.native.stop="reviewData(tr)"
              >
                <div class="mainImage">
                  <vue-load-image>
                    <img
                      v-if="tr.display_on_dash == true"
                      slot="image"
                      :src="require('@/assets/images/promo/displayed2x.png')"
                      height="20"
                      width="76"
                    />
                    <img
                      v-if="tr.display_on_dash == false"
                      slot="image"
                      :src="require('@/assets/images/promo/hidden2x.png')"
                      height="20"
                      width="76"
                    />
                    <br />
                    <br />
                    <img
                      v-if="tr.isExpired ? tr.isExpired : false == true"
                      slot="image"
                      :src="require('@/assets/images/promo/expired2x.png')"
                      height="20"
                      width="76"
                    />
                  </vue-load-image>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-row
        class="my-6 w-full"
        vs-justify="center"
        v-if="promoCardsList && promoCardsList.length > 0"
      >
        <div style="width: max-content">
          <vs-pagination
            :total="totalPages"
            v-model="pageIndex"
            @change="getPromoCards"
            v-show="cardListHasData"
          ></vs-pagination>
        </div>
      </vs-row>
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="showDeleteStatus.status"
    >
      <h5>
        {{ showDeleteStatus.msg }}
      </h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="promoIds.status">
      <h5>
        {{ promoIds.msg }}
      </h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="confirmDelete">
      <h5>Are you sure that you want to delete?</h5>
      <vs-row vs-justify="flex-end">
        <vs-button @click="deletePromo" class="mr-4">Yes</vs-button>
        <vs-button @click="confirmDelete = false">No</vs-button>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
import { MenuIcon, XIcon } from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";

import { validateIssuerName, validateCardName } from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import VueLoadImage from "vue-load-image";

import EventBus from "@/event-bus.js";

export default {
  components: {
    MenuIcon,
    XIcon,
    VueLoadImage,
  },
  mixins: [clickaway],
  data() {
    return {
      filterExpired: false,
      timer: false,
      confirmDelete: false,
      cardsList: [],

      actionBtnClr: "#1D2024",
      promoCardsList: [],
      search: "",

      cardListHasData: true,
      pageIndex: 1,
      totalPages: 1,

      selected: [],
      itemsPerPage: 10,

      hashtagList: [],
      toggleColorList: false,
      showDeleteStatus: {
        msg: "",
        status: false,
      },
      showDuplicateStatus: {
        msg: "",
        status: false,
      },

      promoIds: {
        msg: "",
        success: false,
      },
      errors: {
        cardName: {
          msg: "",
          success: false,
        },
      },
      genericErrorMessage,
      toast,
      datatoedit: "",
      datatoduplicate: "",
      isdelete: "",
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  methods: {
    searchHashtags(inp) {
      this.search = inp;
      this.getPromoCards("search");
    },
    async handleFilter() {
      this.toggleColorList = true;
    },
    closeColorList() {
      if (this.toggleColorList) {
        this.toggleColorList = false;
      }
    },
    async addNewData() {
      await this.$router.push({
        name: "add-promo",
        params: {
          pagename: "Add Promo",
        },
      });
    },
    async reviewData(data) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.PromoDetail + data._id)
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.$root.$emit("updateApprovals", {});
                resolve(
                  //console.log(res.data)
                  (this.datatoedit = res.data.data[0])
                );
                await this.$router.push({
                  name: "promo-details",
                  params: {
                    data: this.datatoedit,
                    pagename: "Promo Details",
                  },
                });
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              //console.log(e,"list");
              if (e.response.status == 404) {
                this.datatoedit = "";
              }
              if (e.response.status !== 401 && e.response.status !== 404) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },

    async getPromoCards(name) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        if (
          this.isdelete &&
          this.promoCardsList.length == this.selected.length &&
          this.pageIndex > 1
        ) {
          this.pageIndex -= 1;
        }
        this.selected = [];
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetAllPromos, {
              params: {
                keyword: this.search,
                page: name == "search" ? 1 : this.pageIndex,
                perPage: this.itemsPerPage,
                filterExpired: this.filterExpired,
              }
            })
            .then(async (res) => {
              const promosData = res.data.data
              this.$vs.loading.close();
              if (res.data.success) {
                this.$root.$emit("updateApprovals", {});
                if (name == "search") {
                  this.pageIndex = 1;
                }
                this.totalPages = promosData.pageCount;
                promosData.promos = promosData.promos.map((data)=>{
                    return {
                      ...data, 
                      display_on_dash: data.display_on_dash ? 
                      data.display_on_dash : false
                    }
                });
                resolve(
                  //console.log(res.data)
                  (this.promoCardsList = promosData.promos),
                  (this.hashtagList = promosData.allHashtags),
                  (this.cardListHasData = true)
                );
                if (
                  this.cardListHasData == true &&
                  this.promoCardsList.length > 0
                ) {
                  let currentOffset = new Date().getTimezoneOffset();
                  this.promoCardsList.forEach((promo) => {
                    if (
                      promo.end_date != null &&
                      promo.creator_offset &&
                      promo.creator_offset != currentOffset
                    ) {
                      promo.end_date = new Date(
                        new Date(promo.end_date).getTime() -
                          promo.creator_offset * 60000 +
                          currentOffset * 60000
                      );
                    }
                  });
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.status == 404) {
                this.cardListHasData = false;
                this.promoCardsList = [];
              }
              if (e.response.status !== 401 && e.response.status !== 404) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },

    async deletePromo() {
      this.confirmDelete = false;
      if (this.selected.length == 0) {
        this.showDeleteStatus = {
          msg: "Please select atleast one promo to delete",
          status: true,
        };
      } else {
        this.showDeleteStatus = {
          msg: "",
          status: false,
        };
        let promoId = [];

        await this.selected.forEach(async function (item, index) {
          promoId.push(item._id);
        });
        this.timer = setTimeout(() => {
          this.$vs.loading.close();
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise((resolve, reject) => {
            this.$axios
              .delete(
                this.$ApiKeys.BASE_URL + this.$EndPoints.DeletePromo,
                { 
                  params:{
                    deletedUserCreated:false
                  },
                  data:promoId
                },
              )
              .then(async (res) => {
                this.$vs.loading.close();
                if (res.data.success == true) {
                  this.showDeleteStatus = {
                    msg: res.data.message,
                    status: true,
                  };
                  this.isdelete = true;
                  this.getPromoCards();
                } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                if (e.response.data.errors && e.response.data.errors.promoIds) {
                  this.promoIds = {
                    msg: e.response.data.errors.promoIds,
                    status: true,
                  };
                } else {
                  this.promoIds = {
                    msg: "",
                    status: false,
                  };
                }

                if (
                  !e.response.data.errors &&
                  !e.response.data.errors.promoIds
                ) {
                  if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }
                }
              });
          });
        }, 500);
      }
    },
    async duplicate() {
      if (this.selected.length == 0) {
        this.showDuplicateStatus = {
          msg: "Please select atleast one promo to duplicate",
          status: true,
        };
      } else {
        this.showDuplicateStatus = {
          msg: "",
          status: false,
        };
        let promoId = [];

        await this.selected.forEach(async function (item, index) {
          promoId.push(item._id);
        });
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.selected = [];
          this.$vs.loading.close();
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise(async (resolve, reject) => {
            await this.$axios
              .get(this.$ApiKeys.BASE_URL + this.$EndPoints.PromoDetail + promoId[0])
              .then(async (res) => {
                this.$vs.loading.close();
                if (res.data.success) {
                  this.$root.$emit("updateApprovals", {});
                  resolve(
                    //console.log(res.data)
                    (this.datatoduplicate = res.data.data[0])
                  );
                  await this.$router.push({
                    name: "add-promo",
                    params: {
                      data: this.datatoduplicate,
                      pagename: "Add Promo",
                    },
                  });
                } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                //console.log(e,"list");
                if (e.response.status == 404) {
                  this.datatoduplicate = "";
                }
                if (e.response.status !== 401 && e.response.status !== 404) {
                  this.toast(this.genericErrorMessage());
                }
              });
          });
        }, 500);
      }
    },
  },

  created() {
    EventBus.$emit("resetToggleGroup", true);
    this.getPromoCards();
  },
};
</script>

<style>
@import "./style.css";
</style>
